import useMonetizacion from "@/features/monetizacion/hooks/use-monetizacion";
import { getTransferenciaMetodoMonedaCantidad } from "@/features/monetizacion/shared/utils";
import { Transferencia, TransferenciaRequest } from "@/shared/types/transferencia";
import { useMemo } from "react";

export default function useGetMonedasOfTransferencia(transferencia: Transferencia | TransferenciaRequest | (Transferencia | TransferenciaRequest)[], complete: boolean = false) {
    const monetizacion = useMonetizacion();

    return useMemo(() => {
        if (Array.isArray(transferencia)) {
            return monetizacion.monedas.filter(m => {
                if (complete && !m.hidden) return true;
                for (const tm of monetizacion.transferenciaMetodos) {
                    for (const t of transferencia) {
                        const cantidad = getTransferenciaMetodoMonedaCantidad(t, tm.id, m.id);
                        if (cantidad != 0) return true;
                    }
                }
                return false;
            })
        } else {
            return monetizacion.monedas.filter(m => {
                if (complete && !m.hidden) return true;
                for (const tm of monetizacion.transferenciaMetodos) {
                    const cantidad = getTransferenciaMetodoMonedaCantidad(transferencia, tm.id, m.id);
                    if (cantidad != 0) return true;
                }
                return false;
            })
        }
    }, [transferencia])
}